module.exports = __webpack_public_path__ + "static/media/pet-purple-icon.ab10a6fa.svg";